// Configuration des variables d'environnement
export const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_KEYS = {
  key: process.env.REACT_APP_API_KEY || '',
  secret: process.env.REACT_APP_API_SECRET || ''
};

// Exemple d'utilisation :
// import { backendUrl, API_KEYS } from './config';
// const url = `${backendUrl}/endpoint`;
// const apiKey = API_KEYS.key;
